import React from 'react';

const ChartSVG = ({
  fill
}) => (
  <svg width="90px" height="45px" viewBox="183 83 90 51">
    <path d="M234,128 L273,128 C273,103.147186 252.852814,83 228,83 C203.147186,83 183,103.147186 183,128 L222,128 C222,124.686292 224.686292,122 228,122 C231.313708,122 234,124.686292 234,128 Z" fill={fill}></path>
  </svg>
)

export default ChartSVG;


// WEBPACK FOOTER //
// ./src/assets/svg/chart.js